import { track } from './analytics';

const seen = new Set<string | number>();
// Exact built-in titles only. Customer/provider strings are never transmitted.
const keys: Record<string, string> = {
  'Error': 'generic_error',
  'Something went wrong': 'generic_error',
  'Failed to save': 'save_failed',
  'Permission denied': 'permission_denied',
  'Session expired': 'session_expired',
  'Google Sign In Error': 'google_sign_in_failed',
};
/**
 * Counts `toast.error` only. `toast.warning` / `toast.info` are NOT reported as
 * error_shown, so the absence of error_shown never means an action succeeded.
 * Features that fail with a warning emit their own event instead (the setup
 * wizard sends `wizard_save_failed`, #1657). Classifying warnings here is #1659.
 */
export function reportErrorToast(toast: { id: string | number; type?: string; title?: unknown }): void {
  if (toast.type !== 'error' || seen.has(toast.id)) return;
  seen.add(toast.id);
  if (seen.size > 1000) seen.delete(seen.values().next().value!);
  const messageKey = typeof toast.title === 'string' && Object.prototype.hasOwnProperty.call(keys, toast.title)
    ? keys[toast.title] : 'unclassified_error';
  track('error_shown', { source: 'toast', message_key: messageKey });
}
